module.exports = __webpack_public_path__ + "media/images/icons/clock-b330af09a65496d9cf31401b5c0586e1.svg";